export default "__VITE_ASSET__BYeSyszN__"